import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllAppointmentsCommand } from '@/app/appointment/commands/get-all-appointments.command'
import { CancelAppointmentCommand } from '@/app/appointment/commands/cancel-appointment.command'

const httpClient = new AxiosClient()

export const getAllAppointmentsCommand = new GetAllAppointmentsCommand(httpClient, store)
export const cancelAppointmentCommand = new CancelAppointmentCommand(httpClient, store)
